import script from "./Pla08EditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./Pla08EditPage.vue?vue&type=script&setup=true&lang=js"

import "./Pla08EditPage.vue?vue&type=style&index=0&id=382c1884&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-382c1884"]])

export default __exports__